import { Component, OnInit } from '@angular/core';
import { Helper } from '../shared/helper';

@Component({
  selector: 'app-offline-menu',
  templateUrl: './offline-menu.component.html',
  styleUrls: ['./offline-menu.component.scss']
})
export class OfflineMenuComponent implements OnInit {

  constructor(public helper: Helper) { }

  ngOnInit(): void {
  }

}
